import React from "react";
import useStyles from "./OrderBookItemstyles";
import PriceFormat from "@components/PriceFormat";
import { Grid } from "@material-ui/core";
import { ColProps_3 } from "@core/utils/ColProps";
import Typography from "@components/Typography";
import clsx from "clsx";
import CustomItemTooltip from "./CustomItemTooltip";
import { useTheme } from "@material-ui/core";

const OrderBookItem = (props) => {
  const classes = useStyles(props);
  const theme = useTheme();
  const {
    item,
    index,
    handleClick,
    handleHover,
    handleRemoveHover,
    hoverIndex,
    reverse,
    type,
    activeCal,
    currencyName,
    items,
    percent,
  } = props;

  const getColorPercent = (id) => {
    if (80 <= percent <= 100) {
      return theme.palette.type === "dark"
        ? "secondary.tint15"
        : "secondary.tint60";
    }
    if (60 <= percent <= 40) {
      if (id === 1) {
        return "secondary.tint60";
      } else {
        return theme.palette.type === "dark"
          ? "secondary.tint15"
          : "secondary.tint60";
      }
    }
    if (40 < percent < 20) {
      if (id === 1 && id === 2) {
        return "secondary.tint60";
      } else {
        return theme.palette.type === "dark"
          ? "secondary.tint15"
          : "secondary.tint60";
      }
    }
    if (percent <= 20) {
      return "secondary.tint60";
    }
  };
  return (
    <CustomItemTooltip
      items={items}
      currencyName={currencyName}
      hoverIndex={hoverIndex}
      type={type}
      activeCal={activeCal}
    >
      <Grid
        id={index + 1}
        onMouseEnter={handleHover}
        onMouseLeave={handleRemoveHover}
        onClick={handleClick}
        item
        container
        direction="row"
        className={clsx(
          classes.listItem,
          item.isMyOrder && classes.isMyOrder,
          type === "buy" ? classes.listSellSize : classes.listBuySize,
          index < hoverIndex &&
            clsx(
              reverse
                ? clsx(
                    index === 0 && clsx(classes.lastItem, classes.test),
                    index === hoverIndex - 1 && classes.firstItem
                  )
                : clsx(
                    index === 0 && classes.firstItem,
                    index === hoverIndex - 1 &&
                      clsx(classes.lastItem, classes.test)
                  )
            )
        )}
      >
        <Grid item {...ColProps_3} container justify="center">
          <Typography
            className="1"
            variant="3xs"
            isBold
            color={getColorPercent(1)}
          >
            <PriceFormat price={item.unitPrice} />
          </Typography>
        </Grid>
        <Grid item {...ColProps_3} container justify="center">
          <Typography
            className="2"
            variant="3xs"
            isBold
            color={getColorPercent(2)}
          >
            <PriceFormat price={item.size} />
          </Typography>
        </Grid>
        <Grid item {...ColProps_3} container justify="center">
          <Typography
            className="3"
            variant="3xs"
            isBold
            color={getColorPercent(3)}
          >
            <PriceFormat price={(item.unitPrice * item.size).toFixed(0)} />
          </Typography>
        </Grid>
      </Grid>
    </CustomItemTooltip>
  );
};

export default OrderBookItem;
